module.exports = __webpack_public_path__ + "static/steering-group-967a2ae98f00b3ea247091cdc67326b3.jpg";